<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';

const props = withDefaults(
  defineProps<{
    name?: string | null;
    imageUrl?: string;
    size?: 'large' | 'small';
  }>(),
  {
    name: undefined,
    imageUrl: undefined,
    size: 'large',
  },
);

const logoExists = ref(false);

const label = computed(() => {
  if (!props.name || props.name?.trim() === '') return undefined;

  const words = props.name?.trim().split(/[\s-]+/);

  if (words.length === 1) return words[0].substring(0, 2).toUpperCase();

  const letters = words.map((word) => word.substring(0, 1));

  return [letters[0], letters[letters.length - 1]].join('').toUpperCase();
});

onMounted(() => props.imageUrl && fetch(props.imageUrl).then((res) => (logoExists.value = res.ok)));

const rectangleClasses = computed(() => {
  if (props.size === 'small') {
    return 'size-20 rounded-lg';
  }
  return 'w-full rounded-t-lg';
});

const rectangleAspectRatio = computed(() => (props.size === 'large' ? '3 / 2' : '1 / 1'));

const labelTextSize = computed(() => (props.size === 'large' ? 'text-3xl' : 'text-xl'));
</script>

<template>
  <figure
    class="flex items-center justify-center overflow-hidden bg-grey-100"
    :class="rectangleClasses"
    :style="{ aspectRatio: rectangleAspectRatio }"
  >
    <img
      v-if="logoExists"
      loading="lazy"
      :src="props.imageUrl"
      :alt="props.name ?? ''"
      class="h-full w-full object-cover"
    />
    <span v-else class="font-semibold text-grey-500" :class="labelTextSize">
      {{ label }}
    </span>
  </figure>
</template>
